import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './carousel.css'
export default class CarouselIdeas extends React.Component {

    render() {
        return (
            <Carousel showArrows={true} infiniteLoop={false} showStatus={false} showThumbs={false} autoPlay={false} dynamicHeight={false} interval={1000} emulateTouch={true} swipeable={true} useKeyboardArrows={true}
                renderIndicator={(onClickHandler, isSelected, index, label) => {
                    if (isSelected) {
                        return (
                            <li
                                className={'carousel__li_select'}
                                aria-label={`Selected: ${label} ${index + 1}`}
                                title={`Selected: ${label} ${index + 1}`}
                            />
                        );
                    }
                    return (
                        <li
                            className={'carousel__li'}
                            onClick={onClickHandler}
                            onKeyDown={onClickHandler}
                            value={index}
                            key={index}
                            role="button"
                            tabIndex={0}
                            title={`${label} ${index + 1}`}
                            aria-label={`${label} ${index + 1}`}
                        />
                    );
                }}
            >
                {this.props.elementos.map(elemento => {
                    return elemento
                })}
            </Carousel>
        );
    }
}